import { Commit } from "vuex"

/**
 * Returns a fresh default state for the loading module.
 * @returns {{ isLoading: boolean }}
 */
const getDefaultState = () => {
	return {
		isLoading: false,
	}
}

export default {
	namespaced: true,
	state: getDefaultState(),
	getters: {
		/**
		 * Returns whether the app is currently loading.
		 */
		isLoading(state: { isLoading: boolean }) {
			return state.isLoading
		},
	},
	mutations: {
		/**
		 * Set loading flag.
		 */
		setLoading(state: { isLoading: boolean }, payload: boolean) {
			state.isLoading = payload
		},
	},
	actions: {
		/**
		 * Start global loading indicator.
		 */
		startLoading({ commit }: { commit: Commit }) {
			commit("setLoading", true)
		},
		/**
		 * Stop global loading indicator.
		 */
		stopLoading({ commit }: { commit: Commit }) {
			commit("setLoading", false)
		},
	},
}
